import { cineamoApiClient } from '../../apiClient';
import { ScreenDto } from '../../models/screen/ScreenDto.types';
import { ScreenInputDto } from '../../models/screen/ScreenInputDto.types';
import { ApiErrorResponse } from '../../types/ApiErrorResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

export async function getScreenById(id: number | string): Promise<ApiResponse<ScreenDto>> {
    return cineamoApiClient
        .get(`/screens/${id}`)
        .then((response) => {
            return response.data;
        })
        .catch(() => {
            return null;
        });
}

export async function setScreen(
    cinemaRoomId: number,
    screen: ScreenInputDto
): Promise<ApiResponse<ScreenDto> | ApiErrorResponse<ScreenInputDto>> {
    return cineamoApiClient
        .put(`/cinema-rooms/${cinemaRoomId}/screen`, screen)
        .then((response) => {
            return response.data;
        })
        .catch((error) => error);
}
